import { BookingDetailItemAction } from "PFApp/booking/components/booking_detail_item/index";
import { Inline } from "PFComponents/containers";
import { TooltipIcon } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { ReactElement, ReactNode } from "react";

import css from "./booking_detail_item.module.scss";

const isTextValue = (value: any): boolean => typeof value === "string" || typeof value === "number";

type BookingDetailItemProps = {
  label: string | ReactElement;
  value?: ReactNode;
  infoContent?: ReactNode;
  tooltipInteractive?: boolean;
  actions?: BookingDetailItemAction[];
};

export const BookingDetailItem = ({
  label,
  value,
  infoContent,
  tooltipInteractive,
  actions
}: BookingDetailItemProps) => (
  <div className={css.root}>
    <Inline alignItems="center" justifyContent="space-between">
      <Typography variant="labelRegular">{label}</Typography>
      {!!actions && (
        <Inline>
          {actions.map(({ icon, onClick, tooltip }, index) => (
            <TooltipIcon
              key={index}
              iconName={icon}
              content={tooltip}
              onClick={onClick}
              iconProps={{ size: "xs" }}
            />
          ))}
        </Inline>
      )}
    </Inline>
    <div className={css.container}>
      {isTextValue(value) ? <Typography variant="bodyBold">{value ?? ""}</Typography> : value}
      {!!infoContent && (
        <TooltipIcon
          content={infoContent}
          tooltipProps={{ interactive: tooltipInteractive }}
          iconProps={{ size: "sm" }}
        />
      )}
    </div>
  </div>
);
